// @ts-nocheck
import { call, put, select } from 'redux-saga/effects';
import {
  accountDetailsFetched,
  accountDetailsFailed,
} from '../reducer/userSlice';
import { fetchAccountDetails } from '../api';
import { rewardsRequest } from '../reducer/rewardsSlice';
import { isWeb } from '../storage';

export function* fetchAccountDetailsSaga(action) {
  const { accountId, customerId, isRefresh } = (action && action.payload) || {};
  // If account details already exist in the store and this is not an explicit refresh,
  // skip fetching again to avoid duplicate calls (can happen because multiple
  // components/actions trigger the same saga on login).
  try {
    const isAuthenticated = yield select(
      (state) => state.user?.isAuthenticated
    );
    if (!isAuthenticated) {
      return;
    }

    const existingAccountDetails = yield select(
      (state) => state.user?.accountDetails
    );
    if (!isRefresh && existingAccountDetails) {
      console.log(
        'fetchAccountDetailsSaga: accountDetails already present, skipping fetch'
      );
      return;
    }

    console.log('fetchAccountDetailsSaga');
    const response = yield call(
      fetchAccountDetails,
      'account_details',
      accountId,
      customerId,
      isRefresh
    );
    if (response.accountDetail) {
      yield put(accountDetailsFetched(response.accountDetail));
    } else {
      const {
        status = response?.status ?? response?.statusCode ?? '500',
        errorCode = 'UNKNOWN_ERROR',
        detail = response?.detail ?? 'An unknown error occurred.',
      } = response;
      console.log('fetchAccountDetailsSaga22', response);
      yield put(
        accountDetailsFailed({
          statusCode: status,
          error: {
            errCode: errorCode,
            msg: detail,
          },
        })
      );
    }
  } catch (error) {
    const {
      data: {
        status = '500',
        errorCode = 'UNKNOWN_ERROR',
        detail = error?.message ?? 'An unknown error occurred.',
      },
    } = error;
    yield put(
      accountDetailsFailed({
        statusCode: status,
        error: {
          errCode: errorCode,
          msg: detail,
        },
      })
    );
    console.log('Error Response', error);
  }
}
